import { ICart } from '../../../../types';
import toDataLayerLineItem from './line_item';
import { formatCurrencyToTwoDecimals } from '../../../utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(cart: ICart): Record<string, any> {
  if (!cart) return {};

  type IAccumulator = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any[];
  };

  let lineItemData = {};
  const cartDataLayer = {
    cart_total_value: formatCurrencyToTwoDecimals(cart?.total_amount || 0),
    cart_total_items: cart?.total_quantity,
  };

  if (cart?.line_items?.length > 0) {
    lineItemData = cart.line_items.reduce<IAccumulator>((acc, lineItem) => {
      // check if lineItem is a sample
      if (lineItem.kind !== 'sample') {
        const itemData = toDataLayerLineItem(cart, lineItem, 'cart_product_');

        Object.keys(itemData).forEach((key) => {
          if (acc[key]) {
            acc[key] = acc[key].concat(itemData[key]);
          } else {
            acc[key] = itemData[key];
          }
        });
        return acc;
      }
      return acc;
    }, {});

    return {
      ...cartDataLayer,
      ...lineItemData,
    };
  } else {
    return {};
  }
}
